// A successful HTTP response alone is not proof of durable queue acceptance.
export function isQueueTextAcceptance(response, data, clientMsgId = null) {
  const recovered = data?.duplicate === true
    && data.duplicateReason === "client_message_already_queued"
    && clientMsgId != null
    && String(data.existingClientMsgId) === String(clientMsgId);
  return response?.ok === true
    && data?.ok === true
    && (data.duplicate !== true || recovered)
    && typeof data.id === "string" && data.id.trim().length > 0
    && (data.routedStoreId == null || (Number.isInteger(Number(data.routedStoreId)) && Number(data.routedStoreId) > 0))
    && ["pending", "sending", "retry", "sent"].includes(recovered ? data.duplicateStatus : data.status);
}

export function isConfirmedTextSend(result) {
  return result?.ok === true && result.uncertain !== true
    && typeof result.messageId === "string" && result.messageId.trim().length > 0;
}

export function textSendFailureMessage(result) {
  if (result?.uncertain) {
    return "Não foi possível confirmar o envio. O texto foi mantido. Verifique o histórico antes de tentar novamente para evitar duplicidade.";
  }
  const detail = typeof result?.error === "string" ? result.error.trim() : "";
  return detail
    ? `Mensagem não enviada. ${detail}`
    : "Mensagem não enviada. Tente novamente.";
}

export async function sendConfirmedTextBatch(items, { send, onAccepted, pause }) {
  const acceptedIds = [];
  for (const item of items) {
    let result;
    try {
      result = await send(item);
    } catch (_) {
      return { ok:false, acceptedIds, error:textSendFailureMessage(null) };
    }
    if (!isConfirmedTextSend(result)) {
      return { ok:false, acceptedIds, error:textSendFailureMessage(result) };
    }
    acceptedIds.push(item.id);
    onAccepted?.(item.id);
    if (pause) await pause();
  }
  return { ok:true, acceptedIds };
}